// react
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// components
import { CareProfileFormPage } from '@karehero/llama/pwa/pages/CareProfileFormPage/CareProfileFormPage';

// hooks
import { useCareProfileForm } from 'hooks';
import { useGoBack } from 'hooks/useGoBack';
import { CareProfileCategoryID } from '@karehero/models';

export const BenefitsEligibilityForm = () => {
  // hooks
  const navigate = useNavigate();
  const location = useLocation();
  const goBack = useGoBack();
  const {
    form,
    handlePrintPdf,
    answers,
    title,
    permission,
    handleSave,
    handleCancel,
    trackViewed,
    setAnswers,
    isSubmitting,
    sections,
  } = useCareProfileForm({
    categoryID: CareProfileCategoryID.EligibilityCalculator,
  });

  // effects
  useEffect(trackViewed, [trackViewed]);

  return (
    <CareProfileFormPage
      onBack={goBack}
      title={title}
      fields={form?.fields || {}}
      value={answers}
      onChange={setAnswers}
      onSave={handleSave}
      onCancel={handleCancel}
      onPrint={handlePrintPdf}
      saveLabel='Continue'
      cancelLabel='Previous'
      isDisabled={!permission.isModify}
      isLoading={isSubmitting}
      sections={sections}
      currentPath={location.pathname}
      onNavigateSection={(to) => navigate(to, { replace: true })}
    />
  );
};

export default BenefitsEligibilityForm;
